import React, { useMemo, useState } from "react";
import Card from "../../../../components/Card";
import { Edit } from "lucide-react";
import { Button, Modal, Select } from "antd";
import { useGetSubjectsQuery } from "../../../../hooks/api/Admin/Courses/useGetSubjectsQuery";
import { useUpdateSubjectExpertise } from "../../../../hooks/api/Tutors/UpdateProfile/useUpdateSubjectExpertise";
import GroupOfExpertise from "./GroupOfExpertise";
import UpdateExpertiseSelect from "./UpdateExpertiseSelect";

const Options = (data: any) => {
  const [payload, setPayload] = useState({
    ids: [...data?.data?.areaOfExpertise],
  });

  const page = 1;
  // const { data: courses } = useGetSubjectsQuery({ page });
  const { mutateAsync, isLoading } = useUpdateSubjectExpertise();

  const [selectedSubjects, setSelectedSubjects] = useState({ ids: [] });

  const [availabilityModal, setAvailabilityModal] = useState(false);

  const { data: subjects } = useGetSubjectsQuery({ page: 1, limit: 100 });

  const { Option, OptGroup } = Select;

  type Subject = {
    subject: string;
    id: string;
  };

  type Categories = {
    [categoryName: string]: Subject[];
  };

  // type SubjectsData = {
  //   data?: {
  //     categories?: Categories;
  //   };
  // };
  // const handleChange = (e: any) => {
  //   const name = e.target.name;
  //   const value = e.target.value;
  //   setPayload({ ...payload, [name]: value });
  // };

  const subjectNameToIdMap = useMemo<Record<string, string>>(() => {
    const map: Record<string, string> = {};
    if (subjects?.data?.categories) {
      Object.values(subjects.data.categories).forEach((subjectArray: any) => {
        subjectArray.forEach((subject: any) => {
          map[subject.subject] = subject._id;
        });
      });
    }
    return map;
  }, [subjects]);

  // const updateSelectedSubject = (selectedValues: string[]) => {
  //   const selectedIds = selectedValues
  //     .map((name) => subjectNameToIdMap[name])
  //     .filter(Boolean);
  //   setSelectedSubjects({ ids: selectedIds });
  // };

  return (
    <div>
      {data?.data?.areaOfExpertise && (
        <Card width="12" style={{ marginTop: "10px" }}>
          <div className="flex justify-between items-center mb-3">
            <h1 className="text-xl W2STMedium text-gray700 ">
              Subject Expertise
            </h1>
            <button
              className="text-primary600 flex gap-2 items-center cursor-pointer"
              onClick={() => {
                setAvailabilityModal(true);
              }}
            >
              <Edit size={20} /> Edit
            </button>
          </div>
          <div>
            <span className="blob capitalize text-gray700">
              <GroupOfExpertise areaOfExpertise={data?.data?.areaOfExpertise} />
            </span>
          </div>
        </Card>
      )}
      {data?.data?.preferredLanguage && (
        <Card width="12" style={{ marginTop: "10px" }}>
          <div className="flex justify-between items-center">
            <h1 className="text-xl W2STMedium text-gray700 mb-3">Language</h1>
          </div>
          <div>
            <span className="blob">
              <span className="text-gray700">
                {data?.data?.preferredLanguage}
              </span>
            </span>
          </div>
        </Card>
      )}

      {/* <p className="text-[10px]">
        {JSON.stringify(data?.data?.areaOfExpertise)}
      </p> */}

      <Modal
        width="400px"
        footer={null}
        open={availabilityModal}
        onCancel={() => setAvailabilityModal(false)}
        title="Edit Subject Expertise"
      >
        <div className="mt-4">
          <p className="">Select area of expertise</p>
          {/* {JSON.stringify(selectedSubjects)} */}
          {/* <Select
            mode="multiple"
            maxCount={4}
            // onChange={(value) =>
            //   setSelectedSubjects({ ids: [...selectedSubjects, value] })
            // }
            // onChange={updateSelectedSubject}
            value={selectedSubjects.ids.map(
              (id) =>
                Object.keys(subjectNameToIdMap).find(
                  (name) => subjectNameToIdMap[name] === id
                ) || ""
            )}
            placeholder="Select up to 8 subjects"
            className="w-full mt-2 capitalize"
            size="large"
          >
            {subjects?.data?.categories &&
              Object.entries(subjects.data.categories as Categories).map(
                ([categoryName, subjectArray]) => (
                  <OptGroup key={categoryName} label={categoryName}>
                    {subjectArray.map((subject) => (
                      <Option
                        key={subject.subject}
                        value={subject.subject}
                        className="capitalize"
                      >
                        {subject.subject}
                      </Option>
                    ))}
                  </OptGroup>
                )
              )}
          </Select> */}
          {/* <Select
            mode="multiple"
            maxCount={4}
            onChange={(value) =>
              handleChange({ target: { name: "areaOfExpertise", value } })
            }
            value={payload?.areaOfExpertise || undefined}
            placeholder="Select Option"
            className="w-full mt-2 capitalize"
            size="large"
          >
            <Option value="" disabled>
              Select option
            </Option>
            {courses?.data?.docs?.map(({ subject }: { subject: string }) => (
              <Option key={subject} value={subject} className="capitalize">
                {subject}
              </Option>
            ))}
          </Select> */}
          {/* <Select
            mode="multiple"
            maxCount={10}
            // onChange={handleExpertiseChange}
            // value={payload.ids}
            placeholder="Select Option"
            className="w-full mt-2 capitalize"
            size="large"
          >
            {data?.data?.categories &&
              Object.keys(data.data.categories).map((category) => (
                <OptGroup key={category} label={category}>
                  {data.data.categories[category].map((subject: any) => (
                    <Option
                      key={subject._id}
                      value={subject._id}
                      className="capitalize"
                    >
                      {subject.subject}
                    </Option>
                  ))}
                </OptGroup>
              ))}
          </Select> */}
          <UpdateExpertiseSelect />

          {/* <UpdateExpertiseSelect
            areaOfExpertise={data?.data?.areaOfExpertise || []}
            categories={subjects?.data?.categories || {}}
            value={payload.id}
            onChange={(val) => setPayload((prev) => ({ ...prev, ids: val }))}
          /> */}

          <p className="mt-3 text-gray500">Select maximum of 10</p>
          <Button
            type="primary"
            className="mt-8 w-full"
            size="large"
            loading={isLoading}
            disabled={!availabilityModal}
            onClick={() => {
              mutateAsync(payload, {
                onSuccess: () => {
                  setAvailabilityModal(false);
                },
              });
            }}
          >
            Continue
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default Options;
